/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Fade } from 'react-reveal';
import Slider from 'react-slick';
import { Col, Container, Row } from 'reactstrap';
import ExperienceCard from '../components/ExperienceCard';
import { experience } from '../portfolio';

const settings = {
  dots: true,
  infinite: true,
  speed: 100,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

function Experience() {
  return (
    <section className="section section-lg pb-0 my-5">
      <Container>
        <Fade left duration={1000} distance="40px">
          <Row className="row-grid align-items-center">
            <Col lg={6}>
              <div className="d-flex p-4">
                <div>
                  <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
                    <i className="ni ni-briefcase-24 text-info" />
                  </div>
                </div>
                <div className="pl-4">
                  <h4 className="display-3 text-black">Experience</h4>
                </div>
              </div>
            </Col>
          </Row>
          <Slider {...settings}>
            {experience.map((data) => (
              <ExperienceCard key={data.id} data={data} headerColor={data.headerColor} />
            ))}
          </Slider>
        </Fade>
      </Container>
    </section>
  );
}

export default Experience;
